import React, { useState, useEffect } from "react";
import { Form, Select, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

function CropDown({
  form,
  name,
  pname,
  label,
  width,
  required,
  labelColSpan,
  errorMessage,
  validateFunction,
  defaultValue,
  multiSelect,
  searchable,
  placeholder,
  disabled,
  size,
  url,
  urlData,
  colSpan,
  onChange,
  firstSelected,
  includeAll,
}) {
  //   form.setFieldsValue({ [name]: defaultValue });
  const [options, setOptions] = useState(null);
  const [defaulter, setDefaulter] = useState(null);
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(true);

  function setPhantomData(key, value) {
    const now = new Date();
    const item = {
      value: { options: value },
      expiry: now.getTime() + 600000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getPhantomData(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    return item.value;
  }

  useEffect(() => {
    console.log(urlData["name"]);
    let localData = getPhantomData(urlData["name"]);

    // console.log(urlData, d);
    if (localData) {
      let temp = {};

      let localOptions = [];

      if (includeAll) {
        localOptions.push({ all: "All" });
      }

      console.log(localData);

      if (localData.options) {
        localOptions = [...localOptions, ...localData.options];
      } else {
        localOptions = [...localOptions, ...localData];
      }

      console.log(localOptions, "LOCAL");

      localOptions.forEach((data) => {
        temp[data["label"]] = data["value"];
      });

      setOptions(localOptions);

      setDefaulter(temp);

      if (defaultValue) {
        console.log(temp[defaultValue]);
        form.setFieldsValue({ [name]: temp[defaultValue] });
        form.setFieldsValue({ [pname]: defaultValue });
      }

      setLoading(false);
    } else {
      liracrypt
        .get(url, urlData)
        .then((res, req) => {
          // console.log(res.data);
          // console.log(res.data.data.options);
          let netOptions = [];

          netOptions = [...netOptions, ...res.data.data.options];

          console.log(netOptions, "NETWORK");

          setOptions(netOptions);

          setPhantomData(urlData["name"], res.data.data.options);

          if (includeAll) {
            netOptions.push({ value: "all", label: "All" });
          }

          let temp = {};

          netOptions.forEach((data) => {
            temp[data["label"]] = data["value"];
          });

          setDefaulter(temp);

          if (defaultValue) {
            console.log(temp[defaultValue]);
            form.setFieldsValue({ [name]: temp[defaultValue] });
          }

          setLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          setLoading(false);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  }, []);

  return (
    <>
      <SessionError visible={loginError} />
      {/* <Col span={colSpan ? colSpan : 24}> */}
      <Form.Item
        name={name}
        label={label}
        labelAlign={"left"}
        // labelCol={{ span: labelColSpan ? labelColSpan : 8 }}
        style={{ marginRight: "10px", width: width, fontWeight: 600 }}
        rules={[
          {
            required: required,
            message: errorMessage,
          },

          () => ({
            validator(rule, value) {
              return validateFunction
                ? validateFunction(rule, value)
                : Promise.resolve();
            },
          }),
        ]}
      >
        {options ? (
          <Select
            mode={multiSelect ? "multiple" : null}
            defaultValue={defaultValue ? defaultValue : null}
            disabled={disabled}
            showSearch={searchable}
            loading={loading}
            placeholder={placeholder}
            style={{ fontWeight: 600 }}
            onChange={onChange ? onChange : (value) => {}}
            defaultActiveFirstOption={true}
            options={options}
          >
            {/* {includeAll ? (
            <Select.Option value={"All"} key={1001}>
              {"All"}
            </Select.Option>
          ) : (
            <></>
          )} */}
            {/* {options.map((opt, index) => {
            return (
              <Select.Option value={opt.value} key={index}>
                {opt.label}
              </Select.Option>
            );
          })} */}
          </Select>
        ) : (
          <></>
        )}
      </Form.Item>
      {/* </Col> */}
    </>
  );
}

export default CropDown;
